import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function QueueMusicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"queue_music"}/>
}
